module.exports = __webpack_public_path__ + "media/src/fonts/GothamPro-Medium-f819c5231537901d09e6e28a6bb1c632.woff";